/* Faffies size guide data — Phase 2 hardcoded source.
 * Keys match the `custom.sizing_categories` metafield values used by the drawer.
 * Canonical unit is cm. Inches are computed in custom.js (cm / 2.54).
 * Calculator ranges below are provisional body measurements. Chart columns
 * explicitly distinguish body ranges from flat garment measurements. Shirt
 * lengths/hems and men's shorts lengths/openings are estimates, not supplier
 * measurements; replace them when confirmed values arrive.
 * Sources used: /pages/copy-of-boys-sizing-chart (mens briefs 30-42),
 * /pages/sizing-chart (kids 2-14y), /pages/mens-swim-shorts-size-chart (XS-XXL),
 * /pages/men-s-fitted-tee-size-chart (XS-XXL chest).
 * Kids shorts garment measurements come from the supplied paper-pattern image.
 * It differs from the supplied PDF on some outseam lengths; the image wins.
 * Men's shorts half-waist ranges come from the updated supplier chart.
 * Their calculator waist ranges are derived from half-waist × 2.
 * Estimated shirts: fitted hem is about 2 cm below men's half-chest or 1 cm
 * above women's half-chest; lengths progress 2 cm per size. Oversized aliases
 * add 2 cm length and 6 cm (men) / 5 cm (women) to the flat hem.
 * Estimated men's shorts: outseam 35-45 cm, flat leg opening 28-33 cm.
 * PLACEHOLDER: womens-shirts calculator ranges have no supplied source yet.
 */
window.FaffiesSizeGuides = window.FaffiesSizeGuides || {
  'mens-swim-briefs': {
    label: "Men's Swim Briefs",
    title: "Men's swim briefs",
    audience: 'adult',
    chartColumns: [{ key: 'range', label: 'Waist (body)', format: 'range' }],
    measure: 'waist',
    measureLabel: 'Waist measurement',
    measureHelp: 'Enter your waist measurement to get started.',
    note: 'Body measurements preview. Ranges to be confirmed by Faffies.',
    howToTitle: 'How to measure',
    howToHeading: 'Waist',
    howToBody: 'Measure around your waist, keeping the tape level and comfortably snug.',
    howToImage: 'https://cdn.shopify.com/s/files/1/0687/9100/9519/files/waist.png?v=1789039509',
    howToImageAlt: 'Where to measure your waist',
    howToNote: 'Use body measurements, not the garment measurement.',
    ranges: [
      { size: '30', minCm: 76, maxCm: 81 },
      { size: '32', minCm: 81, maxCm: 86 },
      { size: '34', minCm: 86, maxCm: 91 },
      { size: '36', minCm: 91, maxCm: 96 },
      { size: '38', minCm: 96, maxCm: 102 },
      { size: '40', minCm: 102, maxCm: 107 },
      { size: '42', minCm: 107, maxCm: 112 }
    ]
  },
  'kids-swim-briefs': {
    label: 'Kids Swim Briefs',
    title: 'Kids swim briefs',
    audience: 'kids',
    chartColumns: [{ key: 'range', label: 'Waist (body)', format: 'range' }],
    measure: 'waist',
    measureLabel: 'Waist measurement',
    measureHelp: 'Enter the waist measurement to get started.',
    note: 'Body measurements preview. Ranges to be confirmed by Faffies.',
    howToTitle: 'How to measure',
    howToHeading: 'Waist',
    howToBody: 'Measure around the waist, keeping the tape level and comfortably snug.',
    howToImage: 'https://cdn.shopify.com/s/files/1/0687/9100/9519/files/waist.png?v=1789039509',
    howToImageAlt: 'Where to measure your waist',
    howToNote: 'Use body measurements, not the garment measurement. When between ages, size up.',
    ranges: [
      { size: '2-3y', minCm: 43, maxCm: 47 },
      { size: '3-4y', minCm: 47, maxCm: 51 },
      { size: '5-6y', minCm: 52, maxCm: 57 },
      { size: '7-8y', minCm: 57, maxCm: 61 },
      { size: '9-10y', minCm: 61, maxCm: 67 },
      { size: '11-12y', minCm: 67, maxCm: 73 },
      { size: '13-14y', minCm: 73, maxCm: 79 }
    ]
  },
  'mens-swimwear': {
    label: "Men's Swimwear",
    title: "Men's Swimwear",
    audience: 'adult',
    chartColumns: [
      { key: 'range', label: 'Half-waist (garment)', format: 'range' },
      { key: 'lengthCm', label: 'Length (garment)' },
      { key: 'legOpeningCm', label: 'Leg opening (flat)' }
    ],
    measure: 'waist',
    measureLabel: 'Waist measurement',
    measureHelp: 'Enter your waist measurement to get started.',
    note: 'Half-waist ranges from the supplied swim shorts chart; length and leg opening remain estimates.',
    howToTitle: 'How to measure',
    howToHeading: 'Waist',
    howToBody: 'Measure around your waist, keeping the tape level.',
    howToImage: 'https://cdn.shopify.com/s/files/1/0687/9100/9519/files/waist.png?v=1789039509',
    howToImageAlt: 'Where to measure your waist',
    howToNote: 'Chart: measure your shorts flat across the waistband. Calculator: use your full waist measurement.',
    chartRows: [
      { size: 'XS', minCm: 36, maxCm: 39, lengthCm: 35, legOpeningCm: 28 },
      { size: 'S', minCm: 39, maxCm: 42, lengthCm: 37, legOpeningCm: 29 },
      { size: 'M', minCm: 42, maxCm: 44, lengthCm: 39, legOpeningCm: 30 },
      { size: 'L', minCm: 44, maxCm: 46, lengthCm: 41, legOpeningCm: 31 },
      { size: 'XL', minCm: 46, maxCm: 48, lengthCm: 43, legOpeningCm: 32 },
      { size: 'XXL', minCm: 48, maxCm: 52, lengthCm: 45, legOpeningCm: 33 }
    ]
  },
  'kids-swimwear': {
    label: 'Kids Swimwear',
    title: 'Kids Swimwear',
    audience: 'kids',
    chartColumns: [
      { key: 'waistCm', label: 'Waist (flat)' },
      { key: 'lengthCm', label: 'Outseam length' },
      { key: 'legOpeningCm', label: 'Leg opening (flat)' }
    ],
    chartRows: [
      { size: '2-3y', waistCm: 24.5, lengthCm: 23.5, legOpeningCm: 20.5 },
      { size: '3-4y', waistCm: 26.5, lengthCm: 25, legOpeningCm: 21.5 },
      { size: '5-6y', waistCm: 28.5, lengthCm: 26.5, legOpeningCm: 22.5 },
      { size: '7-8y', waistCm: 30.5, lengthCm: 28, legOpeningCm: 23.5 },
      { size: '9-10y', waistCm: 32.5, lengthCm: 29.5, legOpeningCm: 24.5 },
      { size: '11-12y', waistCm: 34.5, lengthCm: 31, legOpeningCm: 25.5 }
    ],
    measure: 'waist',
    measureLabel: 'Waist measurement',
    measureHelp: 'Enter the waist measurement to get started.',
    note: 'Waist ranges from the Kids Swim Shorts size chart (half-garment × 2).',
    howToTitle: 'How to measure',
    howToHeading: 'Waist',
    howToBody: 'Measure around the waist where the waistband sits, keeping the tape level.',
    howToImage: 'https://cdn.shopify.com/s/files/1/0687/9100/9519/files/waist.png?v=1789039509',
    howToImageAlt: 'Where to measure your waist',
    howToNote: 'Shorts waistbands are elasticated. When between ages, size up.',
    ranges: [
      { size: '2-3y', minCm: 47, maxCm: 51 },
      { size: '3-4y', minCm: 51, maxCm: 55 },
      { size: '5-6y', minCm: 55, maxCm: 59 },
      { size: '7-8y', minCm: 59, maxCm: 63 },
      { size: '9-10y', minCm: 63, maxCm: 67 },
      { size: '11-12y', minCm: 67, maxCm: 71 }
    ]
  },
  'mens-shirts': {
    label: "Men's Shirts",
    title: "Men's shirts",
    audience: 'adult',
    chartColumns: [
      { key: 'range', label: 'Chest (body)', format: 'range' },
      { key: 'lengthCm', label: 'Length (garment)' },
      { key: 'hemCm', label: 'Hem (flat)' }
    ],
    measure: 'chest',
    measureLabel: 'Chest measurement',
    measureHelp: 'Enter your chest measurement to get started.',
    note: 'Body measurements preview. Ranges to be confirmed by Faffies.',
    howToTitle: 'How to measure',
    howToHeading: 'Chest',
    howToBody: 'Measure around the fullest part of your chest, keeping the tape level.',
    howToImage: 'https://cdn.shopify.com/s/files/1/0687/9100/9519/files/chest.png?v=1789039624',
    howToImageAlt: 'Where to measure your chest',
    howToNote: 'Use body measurements, not the garment measurement.',
    ranges: [
      { size: 'XS', minCm: 100, maxCm: 104, lengthCm: 68, hemCm: 49 },
      { size: 'S', minCm: 106, maxCm: 110, lengthCm: 70, hemCm: 52 },
      { size: 'M', minCm: 110, maxCm: 114, lengthCm: 72, hemCm: 54 },
      { size: 'L', minCm: 116, maxCm: 120, lengthCm: 74, hemCm: 57 },
      { size: 'XL', minCm: 120, maxCm: 124, lengthCm: 76, hemCm: 59 },
      { size: 'XXL', minCm: 126, maxCm: 130, lengthCm: 78, hemCm: 62 }
    ]
  },
  'womens-shirts': {
    label: "Women's Shirts",
    title: "Women's shirts",
    audience: 'adult',
    chartColumns: [
      { key: 'range', label: 'Chest (body)', format: 'range' },
      { key: 'lengthCm', label: 'Length (garment)' },
      { key: 'hemCm', label: 'Hem (flat)' }
    ],
    measure: 'chest',
    measureLabel: 'Chest measurement',
    measureHelp: 'Enter your chest measurement to get started.',
    note: 'Placeholder ranges — no live womens source yet. To be confirmed by Faffies.',
    howToTitle: 'How to measure',
    howToHeading: 'Chest',
    howToBody: 'Measure around the fullest part of your chest, keeping the tape level.',
    howToImageAsset: 'womensChestImage',
    howToImageAlt: 'Female measurement illustration showing where to measure around the fullest part of your chest',
    howToNote: 'Use body measurements, not the garment measurement.',
    ranges: [
      { size: 'XS', minCm: 82, maxCm: 86, lengthCm: 61, hemCm: 43 },
      { size: 'S', minCm: 86, maxCm: 90, lengthCm: 63, hemCm: 45 },
      { size: 'M', minCm: 90, maxCm: 96, lengthCm: 65, hemCm: 47.5 },
      { size: 'L', minCm: 96, maxCm: 102, lengthCm: 67, hemCm: 50.5 },
      { size: 'XL', minCm: 102, maxCm: 108, lengthCm: 69, hemCm: 53.5 },
      { size: 'XXL', minCm: 108, maxCm: 114, lengthCm: 71, hemCm: 56.5 }
    ]
  }
};

// These category keys work when assigned in custom.sizing_categories or a fit:
// tag. Existing generic shirt/swimwear keys remain available for older products.
(() => {
  const guides = window.FaffiesSizeGuides;
  const swimShorts = guides['mens-swimwear'];
  if (swimShorts?.chartRows) {
    swimShorts.ranges = swimShorts.chartRows.map((row) => ({
      ...row,
      minCm: row.minCm * 2,
      maxCm: row.maxCm * 2
    }));
  }
  [
    ['mens-fitted-shirts', 'mens-shirts', "Men's Fitted Shirts", 0, 0],
    ['womens-fitted-shirts', 'womens-shirts', "Women's Fitted Shirts", 0, 0],
    ['mens-oversized-shirts', 'mens-shirts', "Men's Oversized Shirts", 2, 6],
    ['womens-oversized-shirts', 'womens-shirts', "Women's Oversized Shirts", 2, 5]
  ].forEach(([key, baseKey, label, extraLength, extraHem]) => {
    const base = guides[baseKey];
    if (!base || guides[key]) return;
    guides[key] = {
      ...base,
      label,
      title: label,
      ranges: base.ranges.map((row) => ({
        ...row,
        lengthCm: row.lengthCm + extraLength,
        hemCm: row.hemCm + extraHem
      }))
    };
  });

  // The new men's shorts category uses the current men's swim shorts sizing.
  // Length and leg opening values in that source are documented estimates.
  if (guides['mens-swimwear'] && !guides['mens-shorts']) {
    guides['mens-shorts'] = {
      ...swimShorts,
      label: "Men's Shorts",
      title: "Men's shorts",
      ranges: swimShorts.ranges.map((row) => ({ ...row }))
    };
  }
})();
